import store from "../store";
import { storeGet, storeSet } from "../localStore";
import { GAMEJUMP_APP_ID } from "../config";
import { getUser } from "@/apis/gameJump";
import { sort_ASCII } from "@/libs/utils";

const gameJumpRoute = async (to, from, next) => {
  // 0.先判断是否为微信内置浏览器
  const { appkey, temp_token_id, type } = handleLocationSearch();
  if (!appkey && !temp_token_id || to.meta.unAuth) {
    next();
    return;
  }
  try {
    const r = await getUser({
      appkey: appkey || 0,
      temp_token_id: temp_token_id || '',
      type: type || ''
    });
    store.commit("gamejump/CHANGE_USERINFO", {
      userInfo: r.content,
      appkey: appkey || 0,
    });
    storeSet("GAMEJUMP_OPEN_ID", r.content.unionid);
    storeSet("GAMEJUMP_APPKEY", appkey || "0");
    
  } catch (error) {
    console.log(error)
  }
  next();
};

const handleLocationSearch = () => {
  try {
    let search = decodeURIComponent(window.location.search);
    // 获取query字符串
    const index = search.indexOf("?");
    search = search.substring(index + 1);
    // 通过&转换为数组（[a=1, b=2]）
    const arr = search.split("&");
    // 循环数组提取key和val 转换为对象（{a:1,b:2}）
    const obj = {};
    arr.forEach((m) => {
      const n = m.split("=");
      obj[n[0]] = n[1];
    });
    return obj;
  } catch (e) {
    console.log("auth", e);
    return {};
  }
};

export default gameJumpRoute;
